import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { useSenderIDService } from 'hooks/messaging/sender-id';
import useValidator from 'hooks/validator';
import React, { useEffect, useState } from 'react';
import { SenderIDValidator } from './validator';
import { InfoBanner } from 'app/shared/info-banner';
import { useTenant } from 'contexts/tenant';

export const SenderIDRequestForm = ({ closeModal, onSave = () => {} }) => {
  const { createSenderId } = useSenderIDService();
  const { tenant } = useTenant();
  const { errors, form_is_valid, validateField } = useValidator(SenderIDValidator);

  const [sender_id, setSenderId] = useState('');
  const [company_name, setCompanyName] = useState('');
  const [use_case, setUseCase] = useState('');

  const [is_saving, setIsSaving] = useState(false);

  useEffect(() => {
    validateField('sender_id', sender_id);
    validateField('company_name', company_name);
    validateField('use_case', use_case);
  }, [sender_id, company_name, use_case]);

  useEffect(() => {
    if (tenant?.name) setCompanyName(tenant.name);
  }, [tenant, closeModal]);

  const clearForm = () => {
    setSenderId('');
    setCompanyName('');
    setUseCase('');
  };

  const submit = async () => {
    const data = {
      company_name,
      use_case,
      sender_id: sender_id.toUpperCase()
    };

    setIsSaving(true);
    const response = await createSenderId({ data });
    setIsSaving(false);
    if (response) {
      clearForm();
      closeModal();
      onSave(response);
    }
  };

  return (
    <>
      <GridRow num_of_columns={1}>
        <InfoBanner message="You will not be able to use a sender ID until the request is granted. Contact info@go-mailer.com for help or enquires." />
      </GridRow>
      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="sender ID" required>
            <SimpleInput value={sender_id} onInput={setSenderId} error={errors.sender_id} />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Company Name" required>
            <SimpleInput disabled value={company_name} error={errors.company_name} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="use case" required>
            <SimpleInput
              placeholder="e.g: Hello Max, your unused credits are waiting"
              value={use_case}
              onInput={setUseCase}
              error={errors.use_case}
            />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={2}>
        <GridColumn />
        <GridColumn>
          <Button
            text="Submit"
            onClick={submit}
            loading={is_saving}
            disabled={is_saving || !form_is_valid}
          />
        </GridColumn>
      </GridRow>
    </>
  );
};
